export default "__VITE_ASSET__BI2qv1wj__"